import { CopilotConversation } from './copilotConversation';

export class CopilotProcessingActivity {
  processingActivityId: number;

  conversation: CopilotConversation;

  constructor() {
    this.processingActivityId = 0;
    this.conversation = new CopilotConversation();
  }
}
